import React, { useMemo, useState } from 'react';
import { Project } from '../../types/project';
import { Organization } from '../../hooks/useOrganization';
import { ProjectTable } from './ProjectTable';
import { NewProjectModal } from './NewProjectModal';

interface OrgTabProps {
  projects: Project[];
  org: Organization;
}

export function OrgTab({ projects, org }: OrgTabProps) {
  const [showNewProject, setShowNewProject] = useState(false);
  const orgProjects = useMemo(
    () => projects.filter(p => p.organizationId === org.id),
    [projects, org.id]
  );

  return (
    <>
      <h2>
        <i className="fas fa-building" aria-hidden="true" /> {org.name} Projects
        {org.roles?.includes('ROLE_ADMIN') && (
          <button className="btn btn-primary pull-right" onClick={() => setShowNewProject(true)}>
            Add a project <i className="fas fa-plus-circle" aria-hidden="true" style={{ color: '#fff' }} />
          </button>
        )}
      </h2>
      <ProjectTable projects={orgProjects} hideCompany />
      {showNewProject && (
        <NewProjectModal organization={org} onClose={() => setShowNewProject(false)} />
      )}
    </>
  );
}
